const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/organization/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/lib/hooks/common/usePermissions';
export const Route = createFileRoute('/(app)/org/$org/settings/organization')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async ctx => {
    await requirePermission('edit_organization')(ctx);
  }
});